// extracted by mini-css-extract-plugin
module.exports = {"assignmentRow":"styles_assignmentRow__3VkS6","titleRowTablet":"styles_titleRowTablet__hHqcA","headerRow":"styles_headerRow__50IBH","sectionRow":"styles_sectionRow__3hzWC"};